<svg id="whiteboard"></svg>
